import about from "../../src/components/community/pages/about";
import email from "../../src/components/community/pages/email"
import files from "../../src/components/community/pages/files"
import members from "../../src/components/community/pages/members"
import attendance from "../../src/components/community/pages/attendance"
import membersAdministration from "../../src/components/community/pages/members_administration"
//import subscriptions from "../../src/components/community/pages/subscriptions"
import inactiveMembers from "../../src/components/community/pages/inactiveMembers";
import events from "../../src/components/community/events";
import tasks from "../../src/components/community/tasks";
import news from "../../src/components/community/news";
import absence from "../../src/components/events/absence.vue"

export default 	[
	{
        path:"about",
        component:about,
        meta:{
            Breadcrumb:'Over',
            AuthRequired:true
        },
    },
    {
        path:"email",
        component:email,
        name: 'email',
        meta:{
            Breadcrumb:'Email',
            AuthRequired:true
        },
    },
    {
        path:"files",
        component:files,
        meta:{
            AuthRequired:true
        },
    },
    {
        path:"attendance",
        component:attendance,
        meta:{
            Breadcrumb:'Absentie',
            AuthRequired:true,
            permissions: ['Ledenadministratie']
        },
    },
    {
        path:"members",
        component:members,
        meta:{
            Breadcrumb:'Leden',
            AuthRequired:true
        },
    },
    {
        path:"members/administration",
        component:membersAdministration,
        meta:{
            Breadcrumb:'Leden',
            AuthRequired:true,
            permissions: ['Ledenadministratie']
        },
    },
    {
        path:"members/inactive",
        component:inactiveMembers,
        meta:{
            Breadcrumb:'Oud Leden',
            AuthRequired:true,
            permissions: ['Ledenadministratie']
        },
    },
    {
        path:"news",
        component:news,
        meta:{
            Breadcrumb:'Nieuws',
            AuthRequired:true,
        },
    },
    {
        path:"events",
        component:events,
        meta:{
            Breadcrumb:'Activiteiten',
            AuthRequired:true
        },
    },
    {
        path:"tasks",
        component:tasks,
        meta:{
            Breadcrumb:'Taken',
            AuthRequired:true
        },
    },
    {
        path:"events/:eventid/absentie",
        component:absence,
        meta:{
            Breadcrumb:'Absentie',
            AuthRequired:true
        },
    },

    // {
    //     path:"subscriptions",
    //     component:subscriptions,
    //     meta:{
    //         Breadcrumb:'Abonnementen',
    //         AuthRequired:true
    //     },
    // },


];
